import { ChangeDetectorRef, Component, Inject,OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DialogService,ImpressionService } from '../../../../../../app/services'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../../app/Interfaces/JSONRpcResponse'
import { of } from 'rxjs'
import { LoadDialogComponent } from '../../dialogs/load-dialog/load.component'

const KEY = 'print-dialog'

@Component({
    selector: 'atyl-print-dialog',
    templateUrl: 'print-dialog.component.html',
    styleUrls: ['./print-dialog.component.scss']
})
@Stringable({
    path: 'views/partials/layout/dialogs/print-dialog',
    key: KEY,
})
export class PrintDialog extends BaseDialogComponent implements OnInit {
    @StringableValues(KEY)
    strings: any
    
     printType:string='complet'
    
    
    demandeform:any;
	isSendToGED: boolean = false;
    
    constructor(
        public dialogRef: MatDialogRef<PrintDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        dialogService: DialogService,
        changeDetectorRef: ChangeDetectorRef,
        private printService: ImpressionService,
    ) {
        super(dialogRef, dialogService, changeDetectorRef)
    }
    
    ngOnInit() {
        if (this.data.formulaire!=undefined)
            this.demandeform=this.data.formulaire;
	}
	
	print() {
		
	
		
		let _options ={
			
		}
		
		if (this.printType=='vide') 
		   _options["wide"]=true;
		 
		if (this.printType=='inserted')
		   _options["nonull"]=true; 

		if (this.isSendToGED)
			_options["GED"] = true;
		
		this.printService.print(this.demandeform.ID, _options).subscribe((res: JSONRpcResponse) => {
				//this.loading = false
				console.log('printed sf', res)
				if (res.result && res.result.url != undefined) {
					//window.open(res.result.url)
					const dial=this.dialogService.open(LoadDialogComponent, {
										               data: {
										                   url: res.result.url
										               },
													   height: "95vh",
													   width: "80%",
													   minimizable: true,
													   maximizable: true,
													   draggable: true,
										           }, (res: any) => {
										               
					})
				}	
				else
					of(window.confirm('Pas de donnée disponible'))
			})
	}
}